// extracted by mini-css-extract-plugin
module.exports = {"root":"buttonTertiary_root__3uXRx"};